import * as React from "react";
import protectedRoute from "./protectedRoute";
import Container from "@mui/material/Container";
import HomeBar from "./HomeBar";
import { MainPageBox } from "./styles/styled";
import { API, graphqlOperation } from "aws-amplify";
import {
  dataJacket,
  datasetIDs,
  termsOfUse,
  contractPolicy,
  dataProtectionRequirements,
  priceBilling,
} from "./graphql/queries";
import DataJacketTabDetail from "./components/dataJacket/dataJacketTab";
import DataJacketTabSummary from "./components/dataJacket/dataJacketSummary";
import { useLocation, useNavigate } from "react-router-dom";
import { convertDateTimeToDate } from "./js/stringHandling";
import { Auth, Hub } from "aws-amplify";
import Footer from "./Footer";

function DataJacketDetail() {
  const [objDataJacket, setDataJacket] = React.useState([]);
  const [favoriteFlag, setfavoriteFlag] = React.useState();
  const [objDataSetList, setDataSetList] = React.useState([]);
  const [objTermOfUse, setObjTermOfUse] = React.useState([]);
  const [objPolicy, setObjPolicy] = React.useState([]);
  const [objProtection, setObjProtection] = React.useState([]);
  const [objPrice, setObjPrice] = React.useState([]);
  const [networkMode, setNetworkMode] = React.useState("createnew"); // redirect: ネットワーク図に戻る、createnew: ネットワーク図新規作成
  const params = useLocation();
  const navigate = useNavigate();
  const [scroll, setScroll] = React.useState(false);
  const [id, setId] = React.useState("");
  const [user, setUser] = React.useState(null);

  //Reset Page Position after redirect---
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [params]);
  //Reset Page Position after redirect---
  function _navigateToPage() {
    const mode = networkMode;
    const rawData = [
      {
        id: 1,
        value: objDataJacket.data_jacket_name,
        datajacketId: objDataJacket.data_jacket_id,
      },
    ];
    navigate("/graph", {
      state: {
        mode,
        rawData,
      },
    });
  }

  async function checkUser() {
    try {
      const data = await Auth.currentUserPoolUser();
      const userInfo = { username: data.username, ...data.attributes };
      setUser(userInfo);
      Auth.currentSession().then().catch();
    } catch (err) {}
  }

  function getDataJacket(objId, userId) {
    try {
      if (objId) {
        API.graphql(graphqlOperation(dataJacket, { id: objId, userId: userId }))
          .then((evt) => {
            //Change DateTime Format before assign
            evt.data.dataJacket.body.data_jacket_date_published =
              convertDateTimeToDate(
                evt.data.dataJacket.body.data_jacket_date_published
              );
            evt.data.dataJacket.body.data_jacket_date_update =
              convertDateTimeToDate(
                evt.data.dataJacket.body.data_jacket_date_update
              );
            setDataJacket(evt.data.dataJacket.body);
          })
          .catch((evt) => {});

        API.graphql(graphqlOperation(termsOfUse, { id: objId }))
          .then((evt) => {
            //Change DateTime Format before assign
            evt.data.termsOfUse.body.data_validity_start =
              convertDateTimeToDate(
                evt.data.termsOfUse.body.data_validity_start
              );
            evt.data.termsOfUse.body.data_validity_end = convertDateTimeToDate(
              evt.data.termsOfUse.body.data_validity_end
            );
            setObjTermOfUse(evt.data.termsOfUse.body);
          })
          .catch((evt) => {});

        API.graphql(graphqlOperation(datasetIDs, { id: objId }))
          .then((evt) => {
            setDataSetList(evt.data.datasetIDs);
          })
          .catch((error) => {});

        API.graphql(graphqlOperation(contractPolicy, { id: objId }))
          .then((evt) => {
            setObjPolicy(evt.data.contractPolicy.body);
          })
          .catch((evt) => {});

        API.graphql(graphqlOperation(dataProtectionRequirements, { id: objId }))
          .then((evt) => {
            setObjProtection(evt.data.dataProtectionRequirements.body);
          })
          .catch((evt) => {});

        API.graphql(graphqlOperation(priceBilling, { id: objId }))
          .then((evt) => {
            setObjPrice(evt.data.priceBilling.body);
          })
          .catch((evt) => {});
      }
    } catch {}
  }

  function getFavDataJacket(objId, userId) {
    API.graphql(graphqlOperation(dataJacket, { id: objId, userId: userId }))
      .then((evt) => {
        //Change DateTime Format before assign
        evt.data.dataJacket.body.data_jacket_date_published =
          convertDateTimeToDate(
            evt.data.dataJacket.body.data_jacket_date_published
          );
        evt.data.dataJacket.body.data_jacket_date_update =
          convertDateTimeToDate(
            evt.data.dataJacket.body.data_jacket_date_update
          );
        setDataJacket(evt.data.dataJacket.body);
      })
      .catch((evt) => {});
  }
  React.useEffect(() => {
    checkUser();
    Hub.listen("auth", (data) => {
      const { payload } = data;
      if (payload.event === "signOut") {
        setUser(null);
      }
    });
    if (params?.state === undefined || params?.state === null) {
      setId(localStorage.getItem("id"));
    }
  }, []);

  React.useEffect(() => {
    if (id) {
      getDataJacket(id, user?.username);
    } else {
      getDataJacket(params?.state?.id, params?.state?.userName);
    }
    if (params?.state?.mode !== undefined) {
      setNetworkMode(params?.state?.mode);
    }
  }, [id]);

  React.useEffect(() => {
    if (id) {
      getFavDataJacket(id, user?.username);
    } else {
      getFavDataJacket(params?.state?.id, params?.state?.userName);
    }
    if (params?.state?.mode !== undefined) {
      setNetworkMode(params?.state?.mode);
    }
  }, [favoriteFlag]);

  function renderSummary() {
    return (
      <DataJacketTabSummary
        dataJacket={objDataJacket}
        networkMode={networkMode}
        networkNavigate={_navigateToPage}
        setScroll={setScroll}
        scroll={scroll}
        user={user?.username}
        setfavoriteFlag={setfavoriteFlag}
      />
    );
  }
  function renderDisplay() {
    return (
      <DataJacketTabDetail
        dataJacket={objDataJacket}
        dataSetIds={objDataSetList}
        termOfUse={objTermOfUse}
        policy={objPolicy}
        price={objPrice}
        protection={objProtection}
        setScroll={setScroll}
        scroll={scroll}
      />
    );
  }
  return (
    <React.Fragment>
      <div
        style={{
          minWidth: "1200px",
        }}
      >
        <HomeBar />
        {renderSummary()}
        <Container maxWidth={false} style={{ width: "75%", marginLeft: "0" }}>
          <MainPageBox>{renderDisplay()}</MainPageBox>
        </Container>
        <Footer />
      </div>
    </React.Fragment>
  );
}

export default protectedRoute(DataJacketDetail);
